module.exports = __webpack_public_path__ + "img/cb.bea0e0b8.png";